import React, { useEffect, useState, useRef } from 'react';
import {
  getLocalStorageMenuItem,
  getOrderBadgeStatusClass,
  SARIconThemeColor,
  setMobileBackColor,
  setMobileCardBorderColor,
  setMobileCardColor,
  setMobileTextColor,
  setMobileTextField_BK_FONT_Border_StyleColor,
} from "../utility";
import { Badge, Container, Navbar, Modal } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import coverSample from "../images/No_Image_Available.jpg";
import no_image from "../images/No_Image_Available.jpg";
import axios from "axios";
import { useQuery } from "react-query";
import "../css/mobileScreens.css";
import Loading from "../common/loading";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Menu, MenuItem, Chip } from "@mui/material";
import { ArrowBackOutlined, ReceiptOutlined, LocationOn, CancelOutlined, MoreVert, MyLocation, Navigation } from "@mui/icons-material";
import { t } from "i18next";
import no_archive from "../images/no_archive.png";
import ErrorDialog from "../common/errorDialog";
import BottomNavBar from "../components/BottomNavBar";
import { MapContainer, TileLayer, Marker, Popup, Polyline, useMap } from "react-leaflet";
import L from 'leaflet';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import Box from '@mui/material/Box';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Toast from '../common/toast';

// Map component to handle center updates
const MapCenterUpdater = ({ center }) => {
  const map = useMap();
  useEffect(() => {
    if (center) {
      map.setView(center, map.getZoom(), { animate: true });
    }
  }, [center, map]);
  return null;
};

// Custom motorcycle icon
const createMotorcycleIcon = (iconUrl) => {
  return L.divIcon({
    className: 'custom-motorcycle-icon',
    html: `
      <div style="
        position: relative;
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
      ">
        <div style="
          position: absolute;
          width: 30px;
          height: 30px;
          background: #4CAF50;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 8px rgba(0,0,0,0.3);
          border: 3px solid white;
        ">
          <img src="${iconUrl || 'https://cdn-icons-png.flaticon.com/512/3097/3097180.png'}" 
               style="width: 20px; height: 20px; filter: brightness(0) invert(1);" />
        </div>
        <div style="
          position: absolute;
          bottom: -5px;
          width: 8px;
          height: 8px;
          background: #4CAF50;
          border-radius: 50%;
          animation: pulse 2s infinite;
        "></div>
      </div>
      <style>
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(2); opacity: 0; }
        }
      </style>
    `,
    iconSize: [50, 50],
    iconAnchor: [25, 25],
  });
};

// Destination marker icon
const destinationIcon = L.divIcon({
  className: 'custom-destination-icon',
  html: `
    <div style="
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    ">
      <div style="
        width: 30px;
        height: 30px;
        background: #FF5722;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 4px 8px rgba(0,0,0,0.3);
        border: 3px solid white;
      ">
        <div style="width: 10px; height: 10px; background: white; border-radius: 50%;"></div>
      </div>
    </div>
  `,
  iconSize: [40, 40],
  iconAnchor: [20, 20],
});

const DeliveryStatusDialog = ({ orderId, show, onHide }) => {
  const [mapCenter, setMapCenter] = useState([24.7136, 46.6753]);
  const [driverLocation, setDriverLocation] = useState(null);
  const [destinationLocation, setDestinationLocation] = useState(null);
  const [allTreeData] = useState(getLocalStorageMenuItem("tree_data") || []);
  const [simulationMode, setSimulationMode] = useState(false);
  const simulationIntervalRef = useRef(null);

  // Simulate location updates for testing
  const startSimulation = () => {
    const start = [24.7136, 46.6753];
    const end = [24.7436, 46.7053];
    let step = 0;
    const totalSteps = 100;

    if (simulationIntervalRef.current) {
      clearInterval(simulationIntervalRef.current);
    }

    simulationIntervalRef.current = setInterval(() => {
      step++;
      const progress = step / totalSteps;

      const lat = start[0] + (end[0] - start[0]) * progress;
      const lng = start[1] + (end[1] - start[1]) * progress;

      setDriverLocation([lat, lng]);
      setMapCenter([lat, lng]);

      if (step >= totalSteps) {
        clearInterval(simulationIntervalRef.current);
        setSimulationMode(false);
      }
    }, 200);
  };

  const stopSimulation = () => {
    if (simulationIntervalRef.current) {
      clearInterval(simulationIntervalRef.current);
      simulationIntervalRef.current = null;
    }
    setSimulationMode(false);
  };

  useEffect(() => {
    return () => {
      if (simulationIntervalRef.current) {
        clearInterval(simulationIntervalRef.current);
      }
    };
  }, []);

  const { data: trackingData, isLoading, isError, refetch } = useQuery(
    ['order-tracking', orderId],
    async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/orders/${orderId}/track`,
        {
          headers: {
            Authorization: `Bearer ${getLocalStorageMenuItem("mobileLoginToken")}`,
            localization: getLocalStorageMenuItem("lang"),
            timeZone: getLocalStorageMenuItem("timezone")?.replace(/["]+/g, '') || ""
          }
        }
      );

      if (response.data.data?.latitude && response.data.data?.longitude) {
        const newLocation = [response.data.data.latitude, response.data.data.longitude];
        setDriverLocation(newLocation);
        setMapCenter(newLocation);
      }

      if (response.data.data?.destination_latitude && response.data.data?.destination_longitude) {
        setDestinationLocation([
          response.data.data.destination_latitude,
          response.data.data.destination_longitude
        ]);
      }

      if (response.data.data?.driver_phone) {
        let phone = response.data.data.driver_phone.trim();
        if (phone.startsWith('0')) {
          phone = '+966' + phone.slice(1);
        } else if (!phone.startsWith('+966')) {
          phone = '+966' + phone;
        }
        response.data.data.driver_phone = phone;
      }

      return response.data;
    },
    {
      enabled: show && !!orderId && !simulationMode,
      refetchInterval: simulationMode ? false : 5000, // Refetch every 5 seconds when not simulating
      refetchIntervalInBackground: true,
    }
  );

  const calculateDistance = (loc1, loc2) => {
    if (!loc1 || !loc2) return null;
    const R = 6371; // Earth's radius in km
    const dLat = (loc2[0] - loc1[0]) * Math.PI / 180;
    const dLon = (loc2[1] - loc1[1]) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(loc1[0] * Math.PI / 180) * Math.cos(loc2[0] * Math.PI / 180) *
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return (R * c).toFixed(2);
  };

  const distance = calculateDistance(driverLocation, destinationLocation);

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header className='alignByLang' closeButton style={{ 
        backgroundColor: setMobileCardColor(),
        borderBottom: `1px solid ${setMobileCardBorderColor()}`
      }}>
        <Modal.Title style={{ color: setMobileTextColor(), width: '100%' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Typography className='alignByLang head-font' variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
              {t('Order Delivery Tracking')}
            </Typography>
            {distance && (
              <Chip 
                icon={<Navigation fontSize="small" />}
                label={`${distance} km`}
                size="small"
                sx={{ 
                  backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor().backgroundColor,
                  color: setMobileTextField_BK_FONT_Border_StyleColor().color,
                  fontWeight: 'bold'
                }}
              />
            )}
          </Box>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ backgroundColor: setMobileBackColor(), padding: '24px' }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Badge style={{
            backgroundColor: getOrderBadgeStatusClass(trackingData?.data?.current_status),
            padding: '8px 16px',
            borderRadius: '20px',
            fontSize: '0.875rem',
            fontWeight: 'bold'
          }}>
            {trackingData?.data?.current_status}
          </Badge>

          {/* Simulation Controls - FOR TESTING ONLY */}

        </Box>

        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <Loading backColor={setMobileBackColor()} />
          </Box>
        ) : isError ? (
          <Card className='alignByLang' sx={{ backgroundColor: setMobileCardColor() }}>
            <CardContent sx={{ textAlign: 'center', py: 3 }}>
              <Typography color="error">
                {t('Failed to load tracking information')}
              </Typography>
            </CardContent>
          </Card>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* Map Section - Moved to top */}
            <Card className='alignByLang' sx={{
              backgroundColor: setMobileCardColor(),
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
              border: `1px solid ${setMobileCardBorderColor()}`,
              borderRadius: '16px',
              overflow: 'hidden'
            }}>
              <CardContent className='alignByLang' sx={{ p: 0 }}>
                <Box sx={{ 
                  height: '400px', 
                  position: 'relative',
                  '& .leaflet-container': {
                    height: '100%',
                    width: '100%',
                    borderRadius: '16px'
                  }
                }}>
                  <MapContainer
                    center={mapCenter}
                    zoom={14}
                    style={{ height: '100%', width: '100%' }}
                    zoomControl={true}
                  >
                    <MapCenterUpdater center={mapCenter} />
                    <TileLayer
                      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                    />

                    {/* Driver Location Marker */}
                    {driverLocation && (
                      <Marker 
                        position={driverLocation} 
                        icon={createMotorcycleIcon(allTreeData?.details?.motor_icon)}
                      >
                        <Popup>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                              {trackingData?.data.driver_name || t('Driver')}
                            </Typography>
                            <Typography variant="caption">
                              {t('Current Location')}
                            </Typography>
                          </Box>
                        </Popup>
                      </Marker>
                    )}

                    {/* Destination Marker */}
                    {destinationLocation && (
                      <Marker position={destinationLocation} icon={destinationIcon}>
                        <Popup>
                          <Box sx={{ textAlign: 'center' }}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                              {t('Destination')}
                            </Typography>
                            <Typography variant="caption">
                              {t('Delivery Location')}
                            </Typography>
                          </Box>
                        </Popup>
                      </Marker>
                    )}

                    {/* Route Line */}
                    {driverLocation && destinationLocation && (
                      <Polyline
                        positions={[driverLocation, destinationLocation]}
                        color="#2196F3"
                        weight={4}
                        opacity={0.7}
                        dashArray="10, 10"
                      />
                    )}
                  </MapContainer>

                  {/* Live indicator badge */}
                  <Box sx={{
                    position: 'absolute',
                    top: 16,
                    right: 16,
                    zIndex: 1000,
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    padding: '6px 12px',
                    borderRadius: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                    fontWeight: 'bold',
                    fontSize: '0.75rem'
                  }}>
                    <Box sx={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      backgroundColor: 'white',
                      animation: 'pulse 2s infinite'
                    }} />
                    {simulationMode ? t('Simulating...') : t('Live Tracking')}
                  </Box>
                </Box>
              </CardContent>
            </Card>

            {/* Driver Information Card */}
            <Card className='alignByLang' sx={{
              backgroundColor: setMobileCardColor(),
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              border: `1px solid ${setMobileCardBorderColor()}`,
              borderRadius: '16px'
            }}>
              <CardContent className='alignByLang'>
                <Typography className='head-font' variant="subtitle1" gutterBottom sx={{
                  fontWeight: 'bold',
                  color: setMobileTextColor(),
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 2
                }}>
                  <DirectionsCarIcon color="primary" fontSize="medium" />
                  {t('Delivery Information')}
                </Typography>
                <Divider sx={{ my: 2, bgcolor: setMobileCardBorderColor() }} />

                <Box className='alignByLang' sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2.5 }}>
                  <Avatar sx={{
                    bgcolor: 'primary.main',
                    width: 48,
                    height: 48
                  }}>
                    <PersonIcon />
                  </Avatar>
                  <Box className='alignByLang' sx={{ flex: 1 }}>
                    <Typography className='sub-font' variant="caption" sx={{ color: setMobileTextColor(), opacity: 0.7 }}>
                      {t('Driver')}
                    </Typography>
                    <Typography className='sub-font' variant="body1" sx={{
                      fontWeight: 'bold',
                      color: setMobileTextColor()
                    }}>
                      {trackingData?.data.driver_name || t('Not assigned yet')}
                    </Typography>
                  </Box>
                </Box>

                <Box className='alignByLang' sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2.5 }}>
                  <IconButton 
                    style={{ padding: 0 }} 
                    onClick={() => window.open(`tel:${trackingData?.data.driver_phone}`, '_self')}
                    disabled={!trackingData?.data.driver_phone}
                  >
                    <Avatar sx={{
                      bgcolor: 'secondary.main',
                      width: 48,
                      height: 48
                    }}>
                      <PhoneIcon />
                    </Avatar>
                  </IconButton>
                  <Box sx={{ flex: 1 }}>
                    <Typography className='sub-font' variant="caption" sx={{ color: setMobileTextColor(), opacity: 0.7 }}>
                      {t('Contact')}
                    </Typography>
                    <Typography className='sub-font' variant="body1" sx={{
                      fontWeight: 'bold',
                      color: setMobileTextColor()
                    }}>
                      {trackingData?.data.driver_phone || t('Not available')}
                    </Typography>
                  </Box>
                </Box>

                <Box className='alignByLang' sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Avatar sx={{
                    bgcolor: 'info.main',
                    width: 48,
                    height: 48
                  }}>
                    <AccessTimeIcon />
                  </Avatar>
                  <Box>
                    <Typography className='sub-font' variant="caption" sx={{ color: setMobileTextColor(), opacity: 0.7 }}>
                      {t('Last Update')}
                    </Typography>
                    <Typography className='sub-font' variant="body1" sx={{
                      fontWeight: 'bold',
                      color: setMobileTextColor()
                    }}>
                      {trackingData?.data.timestamp ?
                        new Date(trackingData.data.timestamp).toLocaleString() :
                        t('Not available')}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </Card>

            {/* Status History Card */}
            <Card sx={{
              backgroundColor: setMobileCardColor(),
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              border: `1px solid ${setMobileCardBorderColor()}`,
              borderRadius: '16px'
            }}>
              <CardContent>
                <Typography className='alignByLang head-font' variant="subtitle1" gutterBottom sx={{
                  fontWeight: 'bold',
                  color: setMobileTextColor(),
                  mb: 2
                }}>
                  {t('Status History')}
                </Typography>
                <Divider sx={{ my: 2, bgcolor: setMobileCardBorderColor() }} />

                <Box sx={{ position: 'relative', pl: 3 }}>
                  <Box sx={{
                    position: 'absolute',
                    left: '11px',
                    top: 0,
                    bottom: 0,
                    width: '2px',
                    backgroundColor: setMobileCardBorderColor()
                  }} />

                  {trackingData?.data.statuses?.map((status, index) => (
                    <Box key={index} sx={{ position: 'relative', mb: 3, display: 'flex', alignItems: 'flex-start' }}>
                      <Box sx={{
                        position: 'absolute',
                        left: '-18px',
                        width: '24px',
                        height: '24px',
                        borderRadius: '50%',
                        backgroundColor: index === 0 ? '#4CAF50' : setMobileCardColor(),
                        border: `3px solid ${index === 0 ? '#4CAF50' : '#9E9E9E'}`,
                        zIndex: 1
                      }} />
                      <Box sx={{ ml: 2 }}>
                        <Typography className='sub-font' sx={{
                          color: setMobileTextColor(),
                          fontWeight: index === 0 ? 'bold' : 'normal',
                          fontSize: '0.95rem'
                        }}>
                          {t(status.status) || ""}
                        </Typography>
                        <Typography className='sub-font' sx={{
                          color: setMobileTextColor(),
                          opacity: 0.6,
                          fontSize: '0.8rem',
                          mt: 0.5
                        }}>
                          {status.date}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
                </Box>
              </CardContent>
            </Card>
          </Box>
        )}
      </Modal.Body>

      <Modal.Footer style={{
        backgroundColor: setMobileCardColor(),
        borderTop: `1px solid ${setMobileCardBorderColor()}`,
        padding: '16px 24px'
      }}>
        <Button
          variant="contained"
          onClick={onHide}
          sx={{
            backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor().backgroundColor,
            color: setMobileTextField_BK_FONT_Border_StyleColor().color,
            textTransform: 'none',
            borderRadius: '12px',
            padding: '10px 32px',
            fontWeight: 'bold',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor().backgroundColor,
              opacity: 0.9,
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }
          }}
        >
          {t('Close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const Orders = () => {
  const queryString = window.location.search;
  const urlParam = new URLSearchParams(queryString);
  const { qrName, qrCode } = useParams();
  const navigate = useNavigate();
  const lang = getLocalStorageMenuItem("lang");
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [showDeliveryDialog, setShowDeliveryDialog] = useState(false);
  const [detailsData] = useState(getLocalStorageMenuItem("tree_data").details || []);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
      setIsDesktop(width >= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [toastSettings, setToastSettings] = useState({
    open: false,
    message: "",
    success: false,
  });
  const [cancelOrderDialog, setCancelOrderDialog] = useState({
    open: false,
    orderId: null,
    orderTotal: 0
  });

  const [menuAnchor, setMenuAnchor] = useState({});

  const handleMenuOpen = (event, orderId) => {
    event.stopPropagation();
    setMenuAnchor((prev) => ({ ...prev, [orderId]: event.currentTarget }));
  };

  const handleMenuClose = (orderId) => {
    setMenuAnchor((prev) => ({ ...prev, [orderId]: null }));
  };

  const { data: publicData, isLoading: publicIsLoading, isError: publicIsError } = useQuery("public-orders", async () => {
    const timeZone = getLocalStorageMenuItem("timezone") ? getLocalStorageMenuItem("timezone") : "";
    const MobileToken = getLocalStorageMenuItem("mobileLoginToken");
    return await axios.get(
      `${process.env.REACT_APP_API}/menus/${qrCode}/public-orders?token=${getLocalStorageMenuItem("mobileLoginToken")}`,
      { headers: { localization: lang, Authorization: `Bearer ${MobileToken}`, timeZone: timeZone.replace(/["]+/g, '') } }
    );
  });

  const handleOpenToast = (message, state) => {
    setToastSettings({
      open: true,
      success: state,
      message: message
    });
  };

  const handleCloseToast = (event, reason) => {
    if (reason === "clickaway") return;
    setToastSettings({ open: false, message: "", success: false });
  };

  const handleBack = () => {
    navigate(
      `/${qrName}/${qrCode}/sections?section=${urlParam.get("section")}&t=${urlParam.get("t")}&lang=${getLocalStorageMenuItem("lang")}`
    );
  };

  const handleDetails = (id) => {
    navigate(
      `/${qrName}/${qrCode}/order-details?orderId=${id}&section=${urlParam.get("section")}&t=${urlParam.get("t")}`
    );
  };

  const handleTrackDelivery = (orderId, e) => {
    e.stopPropagation();
    setSelectedOrderId(orderId);
    setShowDeliveryDialog(true);
  };

  const handleCancelOrder = (orderId, totalOrder = 0, e) => {
    e.stopPropagation();
    setCancelOrderDialog({
      open: true,
      orderId: orderId,
      orderTotal: totalOrder
    });
  };

  const cancelOrderFunc = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/orders/${cancelOrderDialog.orderId}/cancel`,
        {},
        {
          headers: {
            Authorization: `Bearer ${getLocalStorageMenuItem("mobileLoginToken")}`,
            localization: getLocalStorageMenuItem("lang"),
            timeZone: getLocalStorageMenuItem("timezone")?.replace(/["]+/g, '') || ""
          },
          validateStatus: () => true
        }
      );

      if (response.status === 200) {
        handleOpenToast(t("Order cancelled successfully"), true);
        window.location.reload();
      } else {
        handleOpenToast(t(response?.data?.message), false);
      }
    } catch (error) {
      console.error("Error cancelling order:", error);
      handleOpenToast(t("Failed to cancel order"), false);
    }
    setCancelOrderDialog({ open: false, orderId: null, orderTotal: 0 });
  };

  const onImageError = (e) => {
    e.target.src = coverSample;
  };

  if (publicIsLoading) {
    return <Loading backColor={setMobileBackColor()} />;
  }

  if (publicIsError) {
    return <ErrorDialog />;
  }

  return (
    <div className={`min-vh-100`} style={{ backgroundColor: setMobileBackColor() }}>
      <Container fluid>
        <ToastContainer />
        <div className="row">
          <div className={`${isDesktop ? '' : 'col-lg-4'} ms-auto p-0`}>
            <div style={{ marginBottom: isMobile ? "65px" : "0px" }} className={`${isDesktop ? 'container' : ''} mobile-side-screen`}>
              <Navbar
                className={`d-flex justify-content-between align-items-center position-fixed top-0 z-2 mobile-nav`}
                style={{
                  width: "100%",
                  margin: "auto",
                  backgroundColor: setMobileCardColor(),
                }}
              >
                <Button
                  onClick={handleBack}
                  style={{ color: setMobileTextColor() }}
                >
                  <ArrowBackOutlined sx={{ color: setMobileTextColor() }} />
                </Button>

                <Navbar.Brand className="text-center m-0">
                  <p
                    className="mb-1 text-center sub-font"
                    style={{ color: setMobileTextColor() }}
                  >
                    {detailsData?.table}
                  </p>
                </Navbar.Brand>
              </Navbar>

              <div
                className={`mx-2 mb-4 alignByLang ${isDesktop ? 'd-flex justify-content-center flex-wrap gap-2' : ''} `}
                style={{ marginTop: "64px" }}
              >
                {publicData?.data.data?.orders.length > 0 ? (
                  publicData?.data.data?.orders?.filter(o => o.number).map((order) => (
                    <Card
                      key={order.order_id}
                      sx={{
                        mb: 2,
                        width: isDesktop ? "22%" : "100%",
                        backgroundColor: setMobileCardColor(),
                        border: `1px solid ${setMobileCardBorderColor()}`,
                        borderRadius: '16px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.12)',
                          transform: 'translateY(-4px)'
                        }
                      }}
                      onClick={() => handleDetails(order.order_id)}
                    >
                      <Box
                        className="head-font"
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          px: 2,
                          pt: 2,
                          pb: 1
                        }}
                      >
                        <Box sx={{ flex: 1, textAlign: 'center' }}>
                          <Typography variant="h6" sx={{ fontWeight: 'bold', color: setMobileTextColor() }}>
                            {t("Order")} #{order.number}
                          </Typography>
                        </Box>

                        <IconButton onClick={(e) => handleMenuOpen(e, order.order_id)}>
                          <MoreVert sx={{ color: setMobileTextColor() }} />
                        </IconButton>

                        <Menu
                          anchorEl={menuAnchor[order.order_id]}
                          open={Boolean(menuAnchor[order.order_id])}
                          onClose={() => handleMenuClose(order.order_id)}
                          PaperProps={{
                            sx: {
                              backgroundColor: setMobileCardColor(),
                              borderRadius: '12px',
                              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                            }
                          }}
                        >
                          <MenuItem 
                            className="alignByLang sub-font" 
                            onClick={(e) => {
                              e.stopPropagation();
                              handleDetails(order.order_id);
                              handleMenuClose(order.order_id);
                            }}
                            sx={{ 
                              color: setMobileTextColor(),
                              '&:hover': { backgroundColor: setMobileBackColor() }
                            }}
                          >
                            {t("Order details")}
                          </MenuItem>
                          {order.status?.toLowerCase() === "waiting" && (
                            <MenuItem 
                              className="alignByLang sub-font"
                              onClick={(e) => {
                                handleCancelOrder(order.order_id, order.total, e);
                                handleMenuClose(order.order_id);
                              }}
                              sx={{ 
                                color: '#f44336',
                                '&:hover': { backgroundColor: setMobileBackColor() }
                              }}
                            >
                              {t("Cancel Order")}
                            </MenuItem>
                          )}
                        </Menu>
                      </Box>

                      <CardContent sx={{ pt: 1 }}>
                        <Box sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between",
                          alignItems: 'center',
                          mb: 2
                        }}>
                          <Typography
                            className="head-font"
                            variant="subtitle1"
                            sx={{
                              color: setMobileTextColor(),
                              fontWeight: 'bold',
                              display: 'flex',
                              alignItems: 'center'
                            }}
                          >
                            <ReceiptOutlined sx={{ color: setMobileTextColor(), mr: 1 }} fontSize="medium" />
                            {t("Order details")}
                          </Typography>

                          <Chip
                            label={t(order.status) || ""}
                            size="small"
                            sx={{
                              backgroundColor: getOrderBadgeStatusClass(order.status),
                              color: 'white',
                              fontWeight: 'bold',
                              fontSize: '0.75rem',
                              borderRadius: '8px'
                            }}
                          />
                        </Box>

                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), opacity: 0.8 }}>
                              {t("Order Time :")}
                            </Typography>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                              {order.time}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), opacity: 0.8 }}>
                              {t("Customer Name :")}
                            </Typography>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                              {order.customer}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), opacity: 0.8 }}>
                              {t("Total items :")}
                            </Typography>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                              {order.items_count}
                            </Typography>
                          </Box>

                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), opacity: 0.8 }}>
                              {t("Payment method")}:
                            </Typography>
                            <Typography className="sub-font" variant="body2" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                              {order.payment_method}
                            </Typography>
                          </Box>

                          <Divider sx={{ my: 1, bgcolor: setMobileCardBorderColor() }} />

                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography className="sub-font" variant="body1" sx={{ color: setMobileTextColor(), fontWeight: 'bold' }}>
                              {t("Total order")}:
                            </Typography>
                            <Typography className="sub-font" variant="h6" sx={{ 
                              color: setMobileTextField_BK_FONT_Border_StyleColor().backgroundColor, 
                              fontWeight: 'bold', 
                              display: 'flex', 
                              alignItems: 'center' 
                            }}>
                              {order.final_total}{" "}
                              {publicData?.data.data.currency_symbol === "SAR" ? (
                                <img width={20} height={20} src={SARIconThemeColor()} className="mr-1" alt="SAR" />
                              ) : (
                                publicData?.data.data.currency_symbol
                              )}
                            </Typography>
                          </Box>
                        </Box>

                        {order.is_delivery_service && (
                          <Box sx={{ mt: 2 }}>
                            <Button
                              className="alignByLang head-font"
                              variant="contained"
                              fullWidth
                              startIcon={<LocationOn />}
                              onClick={(e) => handleTrackDelivery(order.order_id, e)}
                              sx={{
                                backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor().backgroundColor,
                                color: setMobileTextField_BK_FONT_Border_StyleColor().color,
                                py: 1.5,
                                borderRadius: '12px',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                fontSize: '0.95rem',
                                boxShadow: 'none',
                                '&:hover': {
                                  backgroundColor: setMobileTextField_BK_FONT_Border_StyleColor().backgroundColor,
                                  opacity: 0.9,
                                  boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                                }
                              }}
                            >
                              {t('Track Your Delivery')}
                            </Button>
                          </Box>
                        )}

                        {order.status?.toLowerCase() === "waiting" && (
                          <Box sx={{ mt: 1.5 }}>
                            <Button
                              className='alignByLang head-font'
                              variant="outlined"
                              fullWidth
                              startIcon={<CancelOutlined />}
                              onClick={(e) => handleCancelOrder(order.order_id, order.total, e)}
                              sx={{
                                borderColor: '#f44336',
                                color: '#f44336',
                                py: 1.5,
                                borderRadius: '12px',
                                textTransform: 'none',
                                fontWeight: 'bold',
                                fontSize: '0.95rem',
                                '&:hover': {
                                  borderColor: '#d32f2f',
                                  backgroundColor: 'rgba(244, 67, 54, 0.08)'
                                }
                              }}
                            >
                              {t('Cancel Order')}
                            </Button>
                          </Box>
                        )}
                      </CardContent>
                    </Card>
                  ))
                ) : (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      minHeight: '70vh',
                      backgroundColor: setMobileCardColor(),
                      p: 4,
                      borderRadius: '16px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                    }}
                  >
                    <Box sx={{ width: 180, height: 180, mb: 3 }}>
                      <img src={no_archive} alt="Not Found" style={{ width: '100%', height: '100%', objectFit: 'contain', opacity: 0.7 }} />
                    </Box>
                    <Typography variant="h6" sx={{
                      fontWeight: 'bold',
                      color: setMobileTextColor(),
                      textAlign: 'center',
                      mb: 1
                    }}>
                      {t("There are no orders")}
                    </Typography>
                    <Typography variant="body2" sx={{
                      color: setMobileTextColor(),
                      opacity: 0.6,
                      textAlign: 'center'
                    }}>
                      {t("Your order history will appear here")}
                    </Typography>
                  </Box>
                )}
              </div>
            </div>
          </div>
        </div>
      </Container>

      <DeliveryStatusDialog
        orderId={selectedOrderId}
        show={showDeliveryDialog}
        onHide={() => setShowDeliveryDialog(false)}
      />

      <Dialog
        open={cancelOrderDialog.open}
        onClose={() => setCancelOrderDialog({ open: false, orderId: null, orderTotal: 0 })}
        PaperProps={{
          sx: {
            backgroundColor: setMobileCardColor(),
            color: setMobileTextColor(),
            borderRadius: "16px",
            padding: "8px",
            minWidth: "320px",
            maxWidth: "400px"
          }
        }}
      >
        <DialogTitle className="head-font" sx={{ textAlign: "center", pt: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
            <Avatar sx={{ width: 56, height: 56, bgcolor: '#f443361a' }}>
              <CancelOutlined sx={{ color: '#f44336', fontSize: 32 }} />
            </Avatar>
            <Typography variant="h6" sx={{ fontWeight: 'bold', mt: 1 }}>
              {t("Cancel Order?")}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pb: 2 }}>
          <Typography className="sub-font" sx={{ textAlign: "center", color: setMobileTextColor(), opacity: 0.8 }}>
            {t("Are you sure you want to cancel this order?")}
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 3, px: 3 }}>
          <Button
            onClick={() => setCancelOrderDialog({ open: false, orderId: null, orderTotal: 0 })}
            sx={{
              color: setMobileTextColor(),
              border: `1px solid ${setMobileCardBorderColor()}`,
              borderRadius: "12px",
              padding: "10px 24px",
              textTransform: "none",
              fontWeight: 'bold',
              flex: 1,
              '&:hover': {
                backgroundColor: setMobileBackColor()
              }
            }}
          >
            {t("No, Keep It")}
          </Button>
          <Button
            onClick={cancelOrderFunc}
            sx={{
              backgroundColor: "#f44336",
              color: "white",
              borderRadius: "12px",
              padding: "10px 24px",
              textTransform: "none",
              fontWeight: 'bold',
              flex: 1,
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: "#d32f2f",
                boxShadow: '0 4px 12px rgba(244, 67, 54, 0.3)'
              }
            }}
          >
            {t("Yes, Cancel")}
          </Button>
        </DialogActions>
      </Dialog>

      <Toast
        open={toastSettings.open}
        message={toastSettings.message}
        resetToast={handleCloseToast}
        success={toastSettings.success}
      />

      <BottomNavBar qr={qrCode} qrName={qrName} />
    </div>
  );
};

export default Orders;


